export default "__VITE_ASSET__BcZJ1b6o__"